/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!******************************************!*\
  !*** ./js/sections/brands-collection.js ***!
  \******************************************/
var brandsCollection = () => {
  var updateFilterIndicator = (button, indicator) => {
    if (!button || !indicator) return;
    var buttonRect = button.getBoundingClientRect();
    var containerRect = button.closest('[data-filters-container]').getBoundingClientRect();
    var leftOffset = buttonRect.left - containerRect.left;
    indicator.style.left = "".concat(leftOffset, "px");
  };
  return {
    init: () => {
      var sections = document.querySelectorAll('[data-section-id].brands-collection-section');
      if (!sections.length) {
        console.warn('Brands Collection: No sections found');
        return;
      }
      sections.forEach(section => {
        var filterButtons = section.querySelectorAll('[data-filter]');
        var collectionItems = section.querySelectorAll('[data-collection-item]');
        var filterIndicator = section.querySelector('[data-filter-indicator]');
        var filtersContainer = section.querySelector('[data-filters-container]');
        if (!filterButtons.length) {
          console.warn('Brands Collection: No filter buttons found');
          return;
        }
        if (!collectionItems.length) {
          console.warn('Brands Collection: No collection items found');
          return;
        }

        // Add class to items in last row for proper border handling
        var updateLastRowBorders = () => {
          var visibleItems = Array.from(collectionItems).filter(item => item.style.display !== 'none');
          if (visibleItems.length === 0) return;

          // Get columns from CSS or default
          var grid = section.querySelector('[data-collections-grid]');
          var computedStyle = window.getComputedStyle(grid);
          var columns = computedStyle.gridTemplateColumns.split(' ').length;

          // Remove previous last-row class
          visibleItems.forEach(item => item.classList.remove('brands-collection__item--last-row'));

          // Calculate last row start index
          var totalItems = visibleItems.length;
          var lastRowStart = Math.floor((totalItems - 1) / columns) * columns;

          // Add class to items in last row
          visibleItems.forEach((item, index) => {
            if (index >= lastRowStart) {
              item.classList.add('brands-collection__item--last-row');
            }
          });
        };

        // Function to scroll to show next button after clicked button
        var scrollToShowNext = (clickedButton, container) => {
          if (!clickedButton || !container) return;

          // Find the next button (sibling)
          var nextButton = clickedButton.nextElementSibling;
          if (!nextButton) return; // No next button

          var containerRect = container.getBoundingClientRect();
          var nextButtonRect = nextButton.getBoundingClientRect();

          // Check if next button is fully visible
          var isNextButtonVisible = nextButtonRect.left >= containerRect.left && nextButtonRect.right <= containerRect.right;

          // If next button is not fully visible, scroll to show it
          if (!isNextButtonVisible) {
            // Calculate scroll position to show the next button
            var scrollLeft = nextButton.offsetLeft - container.offsetLeft - container.offsetWidth / 2 + nextButton.offsetWidth / 2;
            container.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        };

        // Function to filter items
        var filterItems = filterLetter => {
          collectionItems.forEach(item => {
            var itemLetter = item.getAttribute('data-filter-letter');
            // When 'All' is selected, show ALL items
            if (filterLetter == 'All') {
              item.style.display = '';
            } else if (itemLetter === filterLetter) {
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          });
        };

        // Set initial filter indicator position and apply initial filter
        var firstButton = filterButtons[0];
        if (firstButton && filterIndicator) {
          updateFilterIndicator(firstButton, filterIndicator);
          var initialFilter = firstButton.getAttribute('data-filter');
          filterItems(initialFilter);
        }

        // Filter button click handlers
        filterButtons.forEach(button => {
          button.addEventListener('click', () => {
            // Prevent click if button is disabled
            if (button.disabled || button.classList.contains('brands-collection__filter-btn--disabled')) {
              return;
            }
            var filterLetter = button.getAttribute('data-filter');

            // Scroll to show next button if it's not visible (mobile/tablet)
            if (filtersContainer && window.innerWidth <= 1024) {
              scrollToShowNext(button, filtersContainer);
            }

            // Update button states
            filterButtons.forEach(btn => {
              var isActive = btn === button;
              if (isActive) {
                btn.classList.add('tw-bg-[#027db3]');
                var span = btn.querySelector('span');
                if (span) {
                  span.classList.remove('tw-text-[#666]');
                  span.classList.add('tw-text-white');
                }
              } else {
                btn.classList.remove('tw-bg-[#027db3]');
                var _span = btn.querySelector('span');
                if (_span) {
                  _span.classList.add('tw-text-[#666]');
                  _span.classList.remove('tw-text-white');
                }
              }
            });

            // Update filter indicator position
            if (filterIndicator) {
              updateFilterIndicator(button, filterIndicator);
            }

            // Filter collection items
            filterItems(filterLetter);
            // Update last row borders after filtering
            updateLastRowBorders();
          });
        });

        // Initial last row border update
        updateLastRowBorders();

        // Mobile carousel for filters (if needed)
        if (window.innerWidth <= 767 && filtersContainer) {
          var isDown = false;
          var startX;
          var scrollLeft;
          filtersContainer.addEventListener('mousedown', e => {
            isDown = true;
            filtersContainer.style.cursor = 'grabbing';
            startX = e.pageX - filtersContainer.offsetLeft;
            scrollLeft = filtersContainer.scrollLeft;
          });
          filtersContainer.addEventListener('mouseleave', () => {
            isDown = false;
            filtersContainer.style.cursor = 'grab';
          });
          filtersContainer.addEventListener('mouseup', () => {
            isDown = false;
            filtersContainer.style.cursor = 'grab';
          });
          filtersContainer.addEventListener('mousemove', e => {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - filtersContainer.offsetLeft;
            var walk = (x - startX) * 2;
            filtersContainer.scrollLeft = scrollLeft - walk;
          });

          // Touch events for mobile
          var touchStartX = 0;
          var touchScrollLeft = 0;
          filtersContainer.addEventListener('touchstart', e => {
            touchStartX = e.touches[0].pageX - filtersContainer.offsetLeft;
            touchScrollLeft = filtersContainer.scrollLeft;
          });
          filtersContainer.addEventListener('touchmove', e => {
            if (!e.touches[0]) return;
            var x = e.touches[0].pageX - filtersContainer.offsetLeft;
            var walk = (x - touchStartX) * 2;
            filtersContainer.scrollLeft = touchScrollLeft - walk;
          });

          // Enable horizontal scrolling
          filtersContainer.style.overflowX = 'auto';
          filtersContainer.style.cursor = 'grab';
          filtersContainer.style.scrollBehavior = 'smooth';
        }
      });
    }
  };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (() => {
  brandsCollection().init();
});
/******/ })()
;